import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';

@Component({
  selector: 'app-scenario-category-update',
  templateUrl: './scenario-category-update.component.html',
  styleUrls: ['./scenario-category-update.component.css']
})
export class ScenarioCategoryUpdateComponent implements OnInit {
  category = { title: '', scenario: { id: null } };
  isSubmitting = false;
  scenarios: any[] = [];
  categoryId: string | null = '';

  constructor(
    private scenarioCategoryService: VesselCalculationInventoryService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.categoryId = this.route.snapshot.paramMap.get('id');
    if (this.categoryId) {
      this.loadCategory(this.categoryId);
    }
    this.scenarioCategoryService.getScenarioCategory().subscribe(
      (response) => {
        this.scenarios = response;
      },
      (error) => {
        console.error('Error loading scenarios:', error);
      }
    );
  }

  loadCategory(id: string): void {
    
    this.scenarioCategoryService.getScenarioCategoryById(id).subscribe(
      (response) => {
  
        this.category = {
          ...response,  
        };
  
      },
      (error) => {
        console.error('Error loading category:', error);
      }
    );
  }
  
  

  updateCategory(): void {
    console.log('Checking fields before submission:', this.category);
    
    if (!this.category.title) {
      this.toastr.warning('Please fill in all fields.');
      console.log('Missing fields:', this.category);
      return;
    }
  
    this.isSubmitting = true;
    console.log('Submission in progress...');
    
    this.scenarioCategoryService.updateScenarioCategory(this.category).subscribe(
      (response) => {
        this.toastr.success('Scenario Category updated successfully!');
        this.router.navigate(['/homeAdmin/v2/scenarioCategory']); 
      },
      (error) => {
        console.error('Error updating category:', error);
        this.toastr.error('Failed to update category.');
      }
    ).add(() => {
      this.isSubmitting = false;
    });
  }
  
}